import React from "react";
import { Box, Grid, Typography } from "@mui/material";
// direct import
import "./style.scss";
import AddOns from "./view/add-ons";
import Household from "./view/house-hold";
import RenewalOptions from "./view/renewal";
import AccountInfo from "./view/account-info";
import { MyCheckboxRenewal } from "./checkbox";
import { getCurrency } from "helper/numberFormat";
import MembersValidation from "./view/member-validation";

const RenewalDetails = ({ formik, setSelectedAchCard, setSelectedCard }) => {
  const { values, errors, touched } = formik;
  const currency = getCurrency();
  const getType = values?.formInfo?.membershipPriceType;
  const getRenewalError =
    touched.renewalOptions && Boolean(errors.renewalOptions)
      ? errors.renewalOptions
      : false;

  return (
    <Box className="summary-renewal-container">
      {getType && getType !== "static" && values?.formInfo?.lastYearTotalPaid && values?.formInfo?.showLastYear && (
        <Box className="summary-renewal__card">
          <Grid container spacing={2}>
            {/* <Grid item xs={12} md={6}>
              <Typography className="summary-renewal__label heading">
                Last year's category
              </Typography>
              <Typography className="summary-renewal__value desc">
                Sustaining Member
              </Typography>
            </Grid> */}

            <Grid item xs={12} md={6}>
              <Typography className="summary-renewal__label heading">
                Last year's amount
              </Typography>
              <Typography className="summary-renewal__value desc">
                {currency} {values?.formInfo?.lastYearTotalPaid}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}

      <RenewalOptions
        values={values?.formInfo?.membershipPricing}
        currency={currency}
        selectedValue={values?.renewalOptions}
        setValue={formik.setFieldValue}
        getRenewalError={getRenewalError}
        formInfo={values?.formInfo}
      />

      {Array.isArray(values?.formInfo?.addOns) && values?.formInfo?.addOns.length > 0 && (
        <AddOns
          values={values?.formInfo?.addOns}
          selectedValue={values?.addonsOptions}
          setValue={formik.setFieldValue}
        />
      )}
      {values?.formInfo?.validateContacts && <AccountInfo formik={formik} />}
      {values?.formInfo?.validateFamily && (
        <MembersValidation
          familyList={values?.accountInfo?.family_members ?? []}
          formik={formik}
        />
      )}
      {values?.formInfo?.enableHouseHold && (
        <Household
          data={values?.formInfo?.formTags}
          selectedValue={values?.houseOptions}
          setValue={formik.setFieldValue}
        />
      )}
      {values?.formInfo?.showFinancialAid && <Box className="summary-renewal__card">
        <Typography className="summary-renewal__title">Other</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box className="summary-renewal__checkbox-container">
              <MyCheckboxRenewal
                color="primary"
                checked={values?.finantialAid}
                title="Apply for Financial Aid"
                name="finantialAid"
                onChange={(e) => {
                  formik.setFieldValue("finantialAid", e.target.checked);
                  if (e.target.checked) {
                    formik.setFieldValue("activePayment", "bill-my-account");
                    setSelectedCard(null);
                    setSelectedAchCard(null);
                  } else {
                    formik.setFieldValue("activePayment", "credit-card");
                    const cardSelected = formik?.values?.listCards?.data?.find(
                      (el) => el?.is_default
                    )?.id;
                    const cardConfirmed =
                      cardSelected ?? formik?.values?.listCards?.data?.[0]?.id;
                    setSelectedCard(cardConfirmed);
                  }
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>}
    </Box>
  );
};

export default RenewalDetails;
